import numberPlate from './numberPlate'
export default {
  ...numberPlate
}
